import { faker } from '@faker-js/faker'

import { asBuilder } from '../asBuilder'
import {
  ModifyLicenseRepresentativeRequest,
  PartnerLicenseRepresentativeExists,
} from '../../contracts/hospital/PartnerFinancialAct'

export const getPartnerLicenseRepresentativeExists = asBuilder((): PartnerLicenseRepresentativeExists => {
  return {
    exists: faker.datatype.boolean(),
  }
})

export const getModifyLicenseRepresentativeRequest = asBuilder((): ModifyLicenseRepresentativeRequest => {
  return {
    hospitalId: faker.number.int(),
    name: faker.company.name(),
    phoneNumber: faker.phone.number(),
    email: faker.internet.email(),
    agreements: faker.helpers.multiple(() => ({
      version: faker.string.uuid(),
      clauses: faker.helpers.multiple(() => ({
        content: faker.lorem.sentence(),
        isRequired: faker.datatype.boolean(),
        response: faker.datatype.boolean(),
      })),
    })),
  }
})
